module.exports = require("./fr-VU.d.ts");